import React from 'react';

import NativeShare from 'client/components/Result/Share/NativeShare';

function NativeShareWrapper({ title, url, children }) {
    const shareData = {
        title,
        url: url
    };
    const canUseShare =
        navigator.canShare && navigator.canShare(shareData) && /Mobi/i.test(navigator.userAgent);

    return <>{canUseShare ? <NativeShare shareData={shareData} /> : children}</>;
}

export default NativeShareWrapper;
